// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const TP_MOVIMENTO = {
  Entrada: 'TP_MOVIMENTO1',
  Saida: 'TP_MOVIMENTO2',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    TP_MOVIMENTO1: 1,
    TP_MOVIMENTO2: 2
  }
}
